export const OFFER_GENERATED_DESCRIPTION_HOUSE_CONTENT = {
    AVAILABLE_HOUSES_HEADER: "Dostępne są domy:"
} as const;
export const OFFER_GENERATED_DESCRIPTION_HOUSE_CONTENT = {
    AVAILABLE_HOUSES_HEADER: "Dostępne są domy:"
} as const;
